import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../Services/AppContext';
import { loadDOMComponent } from '../../../helpers';
import WorkplaceCalendar from './../WorkplaceCalendar';
import { store } from '../../../store/store';
import { Provider } from 'react-redux';
import { HealthPlanCode } from '../../../Enums/HealthPlanCode.enum';
import { CALENDAR_EVENT_TYPE } from '../CalendarEvent/CalendarEvent';

loadDOMComponent({
	selector: 'react-health-plan-calendar',
	callback: ({ container }) => {
		const workplaceId = container.getAttribute('workplaceId');
		const patientId = container.getAttribute('patientId');
		const healthPlanCode = container.getAttribute('healthPlanCode');
		const params = JSON.parse(container.getAttribute('params'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<WorkplaceCalendar
						workplaceId={workplaceId}
						patientId={patientId}
						params={params}
						healthPlanCode={healthPlanCode}
						calendarEventType={CALENDAR_EVENT_TYPE.HEALTH_PLAN_EVENT}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
